import { render } from "./RelaxPage.vue?vue&type=template&id=2e0b4e7f"
import script from "./RelaxPage.vue?vue&type=script&lang=js"
export * from "./RelaxPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__